export default __webpack_public_path__ + "static/media/benefit-3.aec97bdb.svg";